module.exports = __webpack_public_path__ + "static/media/ship.af9d99bb.svg";